import {
  AutoComplete,
  Avatar,
  Button,
  Drawer,
  Form,
  Input,
  Select,
  Spin,
} from "antd";
import React, { useCallback, useEffect, useRef, useState } from "react";
import axios from "axios";
import { useLocation } from "react-router-dom";
import { authenticateToken } from "../../utils/auth";
import {
  getImgUrl,
  getPage,
  getParamValue,
  jcTypeArray,
} from "../../utils/index";
import Loading from "../common/Loader";
import PaginationTwo from "../common/PaginationTwo";
import { debounce } from "lodash";
import Empty from "../common/Empty";
import AddCategory from "./AddCategory";
import { EditOutlined } from "@ant-design/icons";
import SingleCategory from "./Details/details";
const { Option } = Select;

const GlobalSubCategoryList = () => {
  const [type, setType] = useState("JC_MART");
  // const [confirmLoading, setConfirmLoading] = useState(undefined);
  const [visible, setVisible] = useState(undefined);
  const [key, setKey] = useState("");
  const [selectedCategory, setSelectedCategory] = useState(undefined);
  const [selectedCategoryForEdit, setSelectedCategoryForEdit] =
    useState(undefined);
  const [status, setStatus] = useState("");
  const [limit, setLimit] = useState(16);

  const [form] = Form.useForm();
  const loc = useLocation();
  const page = getParamValue(loc.search, "page");
  const [parentId, setParentId] = useState("");
  const [parentCategoryOptions, setParentCategoryOptions] = useState({
    loading: false,
    list: [],
  });

  const [categoryOptions, setCategoryOptions] = useState({
    loading: false,
    list: [],
  });

  const [categoryData, setCategoryData] = useState({
    loading: false,
    data: null,
  });

  const getCategories = useCallback(async () => {
    setCategoryData({ loading: true, data: null });
    const encodedUri = `${process.env.REACT_APP_CATALOG_READER_API}`;
    axios
      .get(
        `${encodedUri}/admin/category/child-by-type?page=${page || 0}&limit=${
          limit || 16
        }` +
          (type ? `&type=${type}` : ``) +
          (status ? `&status=${status}` : ``) +
          (key ? `&key=${key}` : ``) +
          (parentId ? `&parentCategory=${parentId}` : ``),
        {
          headers: {
            Authorization: `Bearer ${authenticateToken()}`,
          },
        }
      )
      .then((res) => {
        setCategoryData({ loading: false, data: res.data });
      })
      .catch((err) => {
        setCategoryData({ loading: false, data: [] });
        console.error("Category: Error", err);
      });
  }, [limit, parentId, status, page, type, key]);

  const getParentCategoriesOptions = useCallback(
    async (key?: string) => {
      setParentCategoryOptions({ loading: true, list: [] });
      const encodedUri = `${process.env.REACT_APP_CATALOG_READER_API}`;
      const res = await axios.get(
        `${encodedUri}/admin/category/parent-by-type?page=0&limit=20&isParent=false` +
          (key ? `&key=${key}` : ``) +
          (type ? `&type=${type}` : ``),
        {
          headers: {
            Authorization: `Bearer ${authenticateToken()}`,
          },
        }
      );

      setParentCategoryOptions({
        loading: false,
        list: res.data?.categories?.map((category) => ({
          label: category.title,
          value: category.id,
        })),
      });
    },
    [key, type]
  );

  const getCategoriesOptions = useCallback(
    async (key?: string) => {
      setCategoryOptions({ loading: true, list: [] });
      const encodedUri = `${process.env.REACT_APP_CATALOG_READER_API}`;
      const res = await axios.get(
        `${encodedUri}/admin/category/child-by-type?page=0&limit=20&isParent=true` +
          (key ? `&key=${key}` : ``) +
          (type ? `&type=${type}` : ``),
        {
          headers: {
            Authorization: `Bearer ${authenticateToken()}`,
          },
        }
      );

      setCategoryOptions({
        loading: false,
        list: res.data?.categories?.map((category) => ({
          label: category.title,
          value: category.title,
        })),
      });
    },
    [key, type]
  );

  // const onDelete = async (id, val: any) => {
  //   setConfirmLoading(id);
  //   if (id) {
  //     await fetch(`${process.env.REACT_APP_CATALOG_WRITER_API}/category`, {
  //       method: "PUT",
  //       headers: {
  //         Authorization: `Bearer ${authenticateToken()}`,
  //         "Content-Type": "application/json",
  //       },
  //       body: JSON.stringify({
  //         id: id,
  //         deleted: !val,
  //       }),
  //     })
  //       .then((res) => res.json())
  //       .then((res) => {
  //         setConfirmLoading(undefined);
  //         if (res.statusCode === 200) {
  //           responseNotification("Status Changed Successfully", "success");
  //           getCategories();
  //           setVisible(false);
  //         } else if (res.status === 500) {
  //           responseNotification("Internal server error", "error");
  //         } else {
  //           responseNotification(res.message || "something wrong", "warning");
  //         }
  //       })
  //       .catch((err) => {
  //         responseNotification(`${"Internal server error"} ${err}`, "error");
  //         console.error("err", err);
  //       });
  //   }
  // };

  useEffect(() => {
    getCategories();
    getCategoriesOptions();
    getParentCategoriesOptions();
  }, [getCategories, getParentCategoriesOptions, getCategoriesOptions]);

  const reseAllFieldData = () => {
    setStatus("");
    setKey("");
    setParentId("");
    form.resetFields();
  };

  useEffect(() => {
    if (visible) {
      setSelectedCategory(undefined);
      setSelectedCategoryForEdit(undefined);
    }
  }, [selectedCategory, selectedCategoryForEdit, visible]);

  useEffect(() => {
    setSelectedCategory(undefined);
    setSelectedCategoryForEdit(undefined);
  }, [visible]);

  const onClose = () => {
    setSelectedCategory(null);
    setSelectedCategoryForEdit(null);
    getCategories();
  };

  const fetchRef = useRef(0);

  const handleSearch = React.useMemo(() => {
    const loadOptions = (value: string, field: string) => {
      fetchRef.current += 1;
      const fetchId = fetchRef.current;

      if (fetchId !== fetchRef.current) {
        return;
      }
      if (value) {
        if (field === "category") getCategoriesOptions(value);
        // else if (field === "region") getRegionsOptions(value);
      }
    };

    return debounce(loadOptions, 800);
  }, [getCategoriesOptions]);

  return (
    <React.Fragment>
      <div className="top-heading-products top-heading-content">
        <div className="container-fluid">
          <div className="row d-flex-sb mb-15">
            <div className="col-lg-6 col-md-6 no-padding">
              <div className="page-heading-content">
                <h2 className="d-flex-l wrap d-flex-nowrap d-flex-base">
                  Sub Category List{" "}
                  <span className="d-flex-l ml-1">
                    {categoryData?.data?.totalElements || 0} Category(s)
                  </span>
                </h2>
              </div>
            </div>
          </div>
        </div>
      </div>
      <section className="search_area">
        <Form form={form} className="search_form">
          <Form.Item initialValue={type}>
            <Select
              placeholder="Product Type"
              onChange={(val) => setType(val)}
              value={type}
            >
              {Object.values(jcTypeArray)?.map((type, i) => (
                <Option value={type} key={i}>
                  {type?.replace("_", " ")}
                </Option>
              ))}
            </Select>
          </Form.Item>

          <Form.Item name="parentCategory_search">
            <Select
              allowClear
              showSearch
              placeholder="Filter by Category"
              optionFilterProp="children"
              onChange={(val) => setParentId(val)}
              onSearch={(e) => handleSearch(e, "parentCategory")}
              filterOption={(input, option) =>
                option.children
                  .toString()
                  .toLowerCase()
                  .indexOf(input.toLowerCase()) >= 0
              }
            >
              {parentCategoryOptions?.list?.length ? (
                <Option value={null}>All Category</Option>
              ) : undefined}
              {parentCategoryOptions?.list?.map((category) => (
                <Option value={category?.value}>{category?.label}</Option>
              ))}
            </Select>
          </Form.Item>

          <Form.Item name="category" initialValue={key}>
            <AutoComplete
              onSearch={(e) => handleSearch(e, "category")}
              onSelect={(val) => setKey(val)}
              options={categoryOptions?.list}
              defaultActiveFirstOption={false}
              notFoundContent={
                categoryOptions?.loading ? <Spin size="small" /> : null
              }
              style={{ minWidth: 300 }}
            >
              <Input.Search
                size="large"
                placeholder="Search by Name"
                onSearch={(val) => {
                  setKey(val);
                  console.log(val);
                }}
                enterButton
                loading={categoryOptions.loading}
                pattern={`[0-9]`}
                maxLength={11}
              />
            </AutoComplete>
          </Form.Item>
        </Form>
        <div className="search_btn">
          <Button type="primary" danger size="large" onClick={reseAllFieldData}>
            Reset
          </Button>
        </div>
      </section>
      <div className="product-list-item-area white-bg section-padding-bottom">
        <div className="container-fluid">
          <div className="row">
            <div className="col-lg-12">
              <div className="product-list-items-inner-content">
                <div className="single-product-wrapper">
                  <div className="single-product-heading major">
                    <span>Category</span>
                  </div>
                  <div className="single-product-heading">
                    <span>Parent</span>
                  </div>
                  <div className="single-product-heading">
                    <span>Type</span>
                  </div>
                  <div className="single-product-heading">
                    <span>Action</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="row">
            {categoryData?.loading ? (
              <Loading />
            ) : (
              <div className="col-lg-12 product-table">
                <div className="product-table-area">
                  {categoryData?.data?.categories?.length ? (
                    categoryData?.data?.categories?.map(
                      (category: any, index: any) => (
                        <React.Fragment key={index}>
                          <div
                            className="single-product-wrapper"
                            onClick={() => setSelectedCategory(category)}
                          >
                            <div className="single-product major">
                              <Avatar
                                shape="square"
                                size={45}
                                src={getImgUrl(category?.image)}
                                className="mr-3"
                              />
                              <span className="name">
                                {category?.title?.toUpperCase()}
                              </span>
                            </div>
                            <div className="single-product">
                              <span className="name">
                                {category?.parent?.title}
                              </span>
                            </div>
                            <div className="single-product">
                              <span className="name">
                                {category?.type?.split("_").join(" ")}
                              </span>
                            </div>

                            {/* <div className="single-product">
                                <Switch
                                  checkedChildren={<CheckOutlined />}
                                  unCheckedChildren={<CloseOutlined />}
                                  defaultChecked={!category?.deleted}
                                  onChange={(val, e) => {
                                    e.preventDefault();
                                    onDelete(category?.id, val);
                                  }}
                                  loading={
                                    confirmLoading &&
                                    category?.id === confirmLoading
                                  }
                                />
                              </div> */}

                            <div className="single-product">
                              <Button
                                onClick={(e) => {
                                  e.preventDefault();
                                  setSelectedCategoryForEdit(category?.id);
                                }}
                              >
                                <EditOutlined />
                              </Button>
                            </div>
                          </div>
                        </React.Fragment>
                      )
                    )
                  ) : (
                    <Empty data="Category" />
                  )}
                </div>
              </div>
            )}
          </div>

          <Drawer
            title={
              selectedCategoryForEdit ? "Edit Category" : "Category Details"
            }
            width={600}
            onClose={() => {
              setSelectedCategory(null);
              setSelectedCategoryForEdit(null);
            }}
            visible={selectedCategory || selectedCategoryForEdit}
            bodyStyle={{ paddingBottom: 80 }}
            footer={
              <div
                style={{
                  textAlign: "right",
                }}
              ></div>
            }
          >
            {selectedCategoryForEdit ? (
              <AddCategory
                onCloseMethod={onClose}
                visibleData={selectedCategoryForEdit}
              />
            ) : (
              <SingleCategory CategoryDetails={selectedCategory} />
            )}
            {console.log("Sel: ", selectedCategoryForEdit)}
          </Drawer>

          <PaginationTwo
            {...categoryData?.data}
            limit={limit}
            page={getPage(loc.search)}
          />
        </div>
      </div>
    </React.Fragment>
  );
};

export default GlobalSubCategoryList;
